import { render, staticRenderFns } from "./DocumentSummary.vue?vue&type=template&id=0b6bc00b&scoped=true"
import script from "./DocumentSummary.vue?vue&type=script&lang=js"
export * from "./DocumentSummary.vue?vue&type=script&lang=js"
import style0 from "./DocumentSummary.vue?vue&type=style&index=0&id=0b6bc00b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6bc00b",
  null
  
)

export default component.exports